module.exports = "https://r.zoocdn.com/_next/static/images/home-worth-901aabd92fb314fecd3cca209a6b9b07.svg";